import { render, staticRenderFns } from "./search-history.vue?vue&type=template&id=16fa43d0&scoped=true"
import script from "./search-history.vue?vue&type=script&lang=js"
export * from "./search-history.vue?vue&type=script&lang=js"
import style0 from "./search-history.vue?vue&type=style&index=0&id=16fa43d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa43d0",
  null
  
)

export default component.exports